export default [
  {
    content: "안전인증 및 안전검사 수검 여부 확인",
    isChecked: "",
  },
  {
    content: "운반구 바깥 위치에 조작스위치 설치 여부",
    isChecked: "",
  },
  {
    content: "운반구 작업자 탑승 금지 경고 표시 확인",
    isChecked: "",
  },
  {
    content: "운반구 전면등 작업자가 보기 쉬운 위치에 적재하중 표시 여부 확인",
    isChecked: "",
  },
  {
    content: "비상정지스위치 정상 기능 확인",
    isChecked: "",
  },
  {
    content: "조작 스위치 운전방향 표시가 정확하게 되어있는지 확인",
    isChecked: "",
  },
  {
    content: "리미트 스위치 정상 설치 및 작동 여부 확인",
    isChecked: "",
  },
  {
    content: "수리·점검 시 주전원 차단 및 “점검중” 표지 게시",
    isChecked: "",
  },
  {
    content: "과부하방지장치, 권과방지장치, 낙하방지장치 등 방호장치 기능 정상작동 확인",
    isChecked: "",
  },
  {
    content: "건물 각 층 승강로 주위 방호울(1.8m이상) 설치 확인",
    isChecked: "",
  },
  {
    content: "화물 운반구 출입문 설치 및 출입문 연동장치 정상 작동 확인",
    isChecked: "",
  },
  {
    content: "달기구용 와이어로프 변형 및 끊어짐 확인",
    isChecked: "",
  },
  {
    content: "달기구용 체인에 균열 또는 변형 여부 확인",
    isChecked: "",
  },
];
